import { Card, CardContent } from '@mui/material';
import { t } from 'i18next';
import React, { useEffect, useMemo, useState } from 'react';
import plusIcon from '../../../assets/svgs/plus.svg';
import AreYouSureModal from '../../../components/common/areYouSureModal';
import GenericPagination from '../../../components/generic-table/generic-pagination';
import GenericTable from '../../../components/generic-table/generic-table';
import sliderService from '../../../services/sliderService';
import { isEmpty } from '../../../utils/common';
import SliderScreenEditModal from './EditSliderModal';
export const sliderText = (text) =>
   t(`components.slider.${text}`);

const SlidersScreen = () => {
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [isCreating, setIsCreating] = useState(false);
   const [currentSliderData, setCurrentSliderData] = useState({});
   const [isSliderModelOpen, setSliderModelOpen] = useState(false);
   const [isDeleteModelOpen, setDeleteModelOpen] = useState(false);
   const [sliderToBeDeleted, setSliderToBeDeleted] = useState(null);
   const [sliderData, setSliderData] = useState([]);

   const getSlider = () => {
      sliderService.getSlider().then((res) => {
         setSliderData(res.data);
      })
   };

   useEffect(() => {
      getSlider();
   }, []);

   const columns = [
      { field: 'id', label: 'No.', align: 'left' },
      {
         field: 'image', label: 'Image', align: 'left', cellComponent: ({ data }) => (
            <div>
               {isEmpty(data) ? (
                  <div className="w-9 h-9 bg-gray6" style={{ borderRadius: '5px' }} />
               ) : (
                  <img
                     src={data}
                     style={{ borderRadius: '5px' }}
                     className="w-9 h-9"
                     alt="preview"
                  />
               )}
            </div>
         ),
      },
      { field: 'title', label: 'Title', align: 'left' },
      { field: 'url', label: 'URL', align: 'left' },
      { field: 'button', label: 'Button', align: 'left' },
      { field: 'text_button', label: 'Button Text', align: 'left' },
      { field: 'slider_order', label: 'Order', align: 'left' },
      // { field: 'status', label: 'Status', align: 'left' },
      { field: 'description', label: 'Description', align: 'left' },
      { field: 'actions', label: 'Actions', align: 'left' },
   ];

   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(event.target.value);
      setPage(0);
   };

   const onNewSlider = () => {
      setIsCreating(true);
      setSliderModelOpen(true);
   };

   const onEdit = (e) => {
      setIsCreating(false);
      setCurrentSliderData(e);
      setSliderModelOpen(true);
   };

   const displayedData = useMemo(() => {
      const start = page * rowsPerPage;
      const end = start + rowsPerPage;
      return sliderData.slice(start, end);
   }, [sliderData, page, rowsPerPage]);

   return (
      <div className="overflow-auto" style={{ margin: 0, padding: 0 }}>
         <div className="flex flex-col h-full p-6">
            <Card>
               <CardContent className="!p-0">
                  <div className="flex flex-row justify-between items-center px-4 pt-[15px]">
                     <div className="flex flex-row items-center">
                        <span className="text-black1 text-xl font-medium">
                           Sliders
                        </span>
                     </div>
                     <button onClick={() => onNewSlider()} className='flex gap-2 items-center h-[40px] rounded-[6px] bg-[#5C1C81] text-white p-2.5'>
                        <img src={plusIcon} alt="plus" /> <span>Create new</span>
                     </button>
                  </div>
                  <div className="flex flex-col overflow-auto">
                     {sliderData.length ? (
                        <>
                           <GenericTable
                              data={displayedData}
                              columns={columns}
                              onEdit={onEdit}
                              onTrash={(id) => { setSliderToBeDeleted(id); setDeleteModelOpen(true) }}
                              className='!pt-[15px] !px-4'
                           />
                           <GenericPagination
                              count={sliderData.length}
                              page={page}
                              rowsPerPage={rowsPerPage}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              setPage={setPage}
                           />
                        </>
                     ) : (
                        <div>No sliders available</div>
                     )}
                  </div>
               </CardContent>
            </Card>
         </div>
         {isSliderModelOpen && <SliderScreenEditModal
            showModal={isSliderModelOpen}
            onClose={() => setSliderModelOpen(false)}
            data={isCreating ? null : currentSliderData}
            getSlider={getSlider}
         />}
         {isDeleteModelOpen && (
            <AreYouSureModal
               title={sliderText('delete_slider_title')}
               content={sliderText('delete_slider_content')}
               firstButton={sliderText('no_go_back')}
               secondButton={sliderText('yes_i_am')}
               showModal={isDeleteModelOpen}
               onClose={() => setDeleteModelOpen(false)}
               onSubmit={() => {
                  sliderService.deleteSlider(sliderToBeDeleted).then((res) => {
                     getSlider();
                     setSliderToBeDeleted(null);
                     setDeleteModelOpen(false);
                  })
               }}
            />
         )}
      </div>
   );
};

export default SlidersScreen;

